import { fieldValue, formatBytes } from "utils/fieldFormat";
export default function StoragePanel({ data, error }) {
  if (!data)
    return (
      <section className="field-panel">
        <div className="field-panel-head">
          <h2>Storage & retention</h2>
        </div>
        <div className="field-panel-body">
          <p className="field-caption">
            {error || "Loading measured storage…"}
          </p>
        </div>
      </section>
    );
  const quotaDays =
    data.days_to_image_quota ??
    (data.image_quota_bytes && data.growth_bytes_day > 0
      ? Math.max(
          0,
          (data.image_quota_bytes - data.image_bytes) / data.growth_bytes_day,
        )
      : null);
  const pct = data.total_bytes
    ? Math.max(0, Math.min(100, (data.used_bytes / data.total_bytes) * 100))
    : 0;
  return (
    <section className="field-panel">
      <div className="field-panel-head">
        <div>
          <h2>Storage & retention</h2>
          <p>
            Originals on media storage · telemetry and metadata in the database
          </p>
        </div>
      </div>
      <div className="field-panel-body">
        <div
          className="field-inline"
          style={{ justifyContent: "space-between", fontSize: 13 }}
        >
          <strong>{formatBytes(data.free_bytes)} free</strong>
          <span>
            {formatBytes(data.used_bytes)} / {formatBytes(data.total_bytes)}
          </span>
        </div>
        <div className="field-storage-bar">
          <span style={{ width: `${pct}%` }} />
        </div>
        <dl className="field-facts" style={{ padding: 0 }}>
          {[
            ["Field camera originals", formatBytes(data.image_bytes)],
            [
              "Observed image growth",
              `${formatBytes(data.growth_bytes_day)} / day`,
            ],
            ["Original retention", fieldValue(data.retention_days, "days")],
            [
              "Thumbnail retention",
              fieldValue(data.thumbnail_retention_days, "days"),
            ],
            ["Original image quota", formatBytes(data.image_quota_bytes)],
            ["Thumbnail quota", formatBytes(data.thumbnail_quota_bytes)],
            [
              "Next original-quota rotation",
              quotaDays !== null
                ? quotaDays > 0
                  ? `${Number(quotaDays).toFixed(1)} days`
                  : "Quota rotation active"
                : "Not enough growth data",
            ],
            [
              "Projected original coverage",
              data.growth_bytes_day > 0 && data.image_quota_bytes
                ? `${Number(data.projected_original_coverage_days ?? Math.min(data.retention_days || Infinity, data.image_quota_bytes / data.growth_bytes_day)).toFixed(1)} days`
                : "Not enough growth data",
            ],
            ["Free-space reserve", formatBytes(data.reserve_bytes)],
            [
              "Time to reserve at observed rate",
              data.days_to_full === null || data.days_to_full === undefined
                ? "Not enough growth data"
                : `${Number(data.days_to_full).toFixed(1)} days`,
            ],
          ].map(([label, value]) => (
            <div className="field-fact" key={label}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
        <p className="field-caption">
          Disk use includes other applications. Growth counts images captured
          over {data.growth_observation_hours?.toFixed(1) || "24"} hours, including
          imported history; it does not indicate live upload throughput. Image
          size, capture frequency and node count change the rate. The shared
          quota cycles out older originals to admit new captures; metadata
          remains in the history and thumbnails have their own retention.
          Projected coverage estimates how much original footage fits at the
          observed rate. The free-space reserve protects the disk if space
          cannot be recovered.
        </p>
        {data.warnings?.map((w) => (
          <p className="field-caption" key={w}>
            {w}
          </p>
        ))}
      </div>
    </section>
  );
}
